﻿'use strict';

angular.module('ntmApp').factory('DefaultGridCustomizer', [function () {

    var customizer = {};

    customizer.buildOptions = function (columnOptions, gridOptions) {

        gridOptions = gridOptions || {};

        gridOptions.columnDefs = columnOptions.map(transformColumnToUiGridColumn);

        return gridOptions;
    };

    customizer.getDefaultOptions = function () {

        var gridOptions = {};

        gridOptions.enableFiltering = false;
        gridOptions.enableSorting = false;
        gridOptions.showFooter = false;
        gridOptions.enableColumnMenus = true;
        gridOptions.enableSorting = true;

        gridOptions.enableGridMenu = true;
        gridOptions.exporterMenuCsv = true;
        gridOptions.exporterMenuPdf = true;
        gridOptions.rowHeight = 40;

        return gridOptions;
    };


    function transformColumnToUiGridColumn(column) {

        var uiGridColumn = {
            field: column.name,
            name: column.name,
            displayName: column.name.replaceAll('_', ' '),
            type: convertToUiGridType(column.type),
            fieldName: column.fieldName,
            enableSorting: true,
            visible: true,
            decimals: column.decimals
        };

        if (column.type === 'DATE') {
            uiGridColumn.cellFilter = 'date:\'MM/dd/yyyy\'';
        }

        if (column.type === 'NUMERIC') {
            uiGridColumn.cellTemplate = '<div class="text-right ui-grid-cell-contents">{{COL_FIELD | number:{0}}}</div>'.format(column.decimals || 0);
        }

        if (column.type === 'CHECKBOX' || column.type === 'RADIOBOOLEAN') {
            uiGridColumn.cellTemplate = '<input ng-if="!row.groupHeader" type=\"checkbox\" ng-checked="COL_FIELD !=false" ng-model="MODEL_COL_FIELD" disabled />';
        }

        return uiGridColumn;
    }

    function convertToUiGridType(type) {

        switch (type) {
            case 'CHECKBOX':
            case 'RADIOBOOLEAN':
                return 'boolean';
            case 'NUMERIC':
                return 'number';
            case 'DATE':
                return 'date';
            default:
                return 'string';
        }
    }


    return customizer;

}]);